{
  "en": {
    "marketplace_partner": {
      "contact_me": {
        "button": "Contact me!",
        "failure": "An unexpected error occurred.",
        "success": "We will get in touch with you shortly."
      }
    }
  }
}
